import { Component, OnInit, Input } from '@angular/core'
import { RequestsService } from 'src/app/_shared/services/requests.service'
import { AuthenticationService } from '../../_services/authentication.service'
import { DiagnosisData } from '../../interfaces/admin.interface'

@Component({
  selector: 'app-diagnosis-table',
  templateUrl: './diagnosis-table.component.html',
  styleUrls: ['./diagnosis-table.component.scss'],
})
export class DiagnosisTableComponent implements OnInit {
  constructor(
    private requestService: RequestsService,
    private authenticationService: AuthenticationService
  ) {}

  @Input() type
  loading: boolean
  deleteDiagnosisloading: boolean
  diagnosisViewData: object
  deleteDiagnosisSuccess: boolean
  showFilter = true
  page = 1
  count = 10
  data: []
  message: string
  category: string
  country_id: string
  countryName: string
  diagnosisId: string
  diagnosisData: object
  diagnosisDeleteData: object
  diagnosisAction: string
  modalId: string
  selectedCrops: any
  selectCrop = []
  selectedName: any
  namesToSelect = []

  ngOnInit() {
    const currentUser = this.authenticationService.getCurrentUserValue()
    const { country_id, country } = currentUser
    this.country_id = country_id
    this.countryName = country
    this.setCategory()
    this.loadDiagnosis()
  }

  setCategory() {
    this.category = this.type === 'Pests' ? 'pest' : 'disease'
  }

  loadDiagnosis(): void {
    this.loading = true
    this.requestService
      .dash_get(`diagnosis/${this.countryName}/${this.category}`, null)
      .subscribe(
        (res) => {
          this.loading = false
          this.data = res.data
          let crops = []
          let names = []
          res.data
            ? res.data.map((each) => {
                names.push({ label: each.name, value: each.name })
                crops.push({ label: each.crop, value: each.crop })
              })
            : null
          this.namesToSelect = names
          this.selectCrop = crops.filter(
            (value, index, array) =>
              !array.filter(
                (v, i) =>
                  JSON.stringify(value) == JSON.stringify(v) && i < index
              ).length
          )
        },
        (err) => {
          this.loading = false
          this.message = err.error
        }
      )
  }

  setDiagnosisView(data: object): void {
    this.diagnosisViewData = data
  }

  setSingleDiagnosisView(data: object): void {
    this.diagnosisDeleteData = data
  }

  deleteDiagnosis(id: string): void {
    this.deleteDiagnosisloading = true
    this.requestService.dash_delete(id, `diagnosis`).subscribe(
      (res) => {
        this.deleteDiagnosisloading = false
        this.deleteDiagnosisSuccess = true
        this.loadDiagnosis()
        this.message = 'Diagnosis information deleted successfully'
      },
      (err) => {
        this.deleteDiagnosisloading = false
        this.deleteDiagnosisSuccess = false
        if (err.status === 404) {
          this.message = 'Diagnosis information not found!'
        } else {
          this.message = 'Some error occurred. Please try again'
        }
      }
    )
  }

  setDiagnosisAction(data: object, action: string, modalId: string): void {
    this.diagnosisData = data
    this.diagnosisAction = action
    this.modalId = modalId
  }

  clearMessage(): void {
    this.message = ''
  }

  Clear(diagnosisT) {
    this.selectedCrops = null
    this.selectedName = null
    diagnosisT.filter(null, 'name', 'in')
    diagnosisT.filter(null, 'crop', 'in')
  }

  closeDiagnosisModal() {
    this.diagnosisData = null
  }

  refreshDiagnosisList() {
    this.loadDiagnosis()
  }
}
